





























import { FlowType } from '@tt4b/ttam-enums';
import { defineComponent, computed } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import { InventoryFlowTypeOptionItem } from '../types';
import { InventoryFlowTypes } from '../consts';
import { PropType } from 'vue';

const name = 'ttam-placement-type-options';

export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    value: {
      type: Number as PropType<FlowType>,
      default: 0,
    },
    disabled: {
      type: Boolean,
      defalut: false,
    },
    options: {
      type: Array as PropType<InventoryFlowTypeOptionItem[]>,
      default: () => InventoryFlowTypes(),
    },
  },
  setup(props, { emit }) {
    const _inventoryFlowType = computed(() => (typeof props.value === 'number' ? props.value : FlowType.AUTO));

    const handleClick = flowType => {
      if (!props.disabled && !flowType.disabled) {
        emit('change', flowType.value);
        emit('input', flowType.value);
      }
    };

    return {
      name,
      _inventoryFlowType,
      FlowType,
      handleClick,
    };
  },
});
